/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ xp: NonNullable<unknown>, level: NonNullable<unknown> }} Profile_Hero_Xptonextlevel3Inputs */

const id_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} XP ke level ${i?.level}`)
};

const ms_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} XP ke tahap ${i?.level}`)
};

const da_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} XP til niveau ${i?.level}`)
};

const de_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} XP bis Level ${i?.level}`)
};

const en_us2_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} XP to level ${i?.level}`)
};

const es_es2_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} XP hasta el nivel ${i?.level}`)
};

const es_mx2_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} XP hasta el nivel ${i?.level}`)
};

const fil_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} XP hanggang level ${i?.level}`)
};

const fr_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} XP jusqu'au niveau ${i?.level}`)
};

const it_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} XP al livello ${i?.level}`)
};

const hu_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} XP a ${i?.level}. szintig`)
};

const nl_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} XP naar niveau ${i?.level}`)
};

const no_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} XP til nivå ${i?.level}`)
};

const pl_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} XP do poziomu ${i?.level}`)
};

const pt_br2_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} XP para nivelar ${i?.level}`)
};

const pt_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} XP para o nível ${i?.level}`)
};

const ro_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} XP până la nivelul ${i?.level}`)
};

const fi_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} XP tasolle ${i?.level}`)
};

const sv_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} XP till nivå ${i?.level}`)
};

const vi_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} XP để lên cấp ${i?.level}`)
};

const tr_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.level}. seviye için ${i?.xp} XP`)
};

const cs_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} XP do úrovně ${i?.level}`)
};

const bg_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} XP до ниво ${i?.level}`)
};

const ru_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} опыта (XP) до уровня ${i?.level}`)
};

const uk_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} XP до рівня ${i?.level}`)
};

const ar_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} XP للمستوى ${i?.level}`)
};

const hi_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`स्तर ${i?.level} के लिए ${i?.xp} XP`)
};

const th_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} XP สู่เลเวล ${i?.level}`)
};

const ja_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`次のレベル${i?.level}まで ${i?.xp} XP`)
};

const zh_cn2_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`距离 ${i?.level} 级还差 ${i?.xp} XP`)
};

const zh_hant1_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`距離 ${i?.level} 級還差 ${i?.xp} XP`)
};

const ko_profile_hero_xptonextlevel3 = /** @type {(inputs: Profile_Hero_Xptonextlevel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`레벨 ${i?.level}까지 ${i?.xp} XP`)
};

/**
* | output |
* | --- |
* | "{xp} XP to level {level}" |
*
* @param {Profile_Hero_Xptonextlevel3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_hero_xptonextlevel3 = /** @type {((inputs: Profile_Hero_Xptonextlevel3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Hero_Xptonextlevel3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_hero_xptonextlevel3(inputs)
	if (locale === "ms") return ms_profile_hero_xptonextlevel3(inputs)
	if (locale === "da") return da_profile_hero_xptonextlevel3(inputs)
	if (locale === "de") return de_profile_hero_xptonextlevel3(inputs)
	if (locale === "en-US") return en_us2_profile_hero_xptonextlevel3(inputs)
	if (locale === "es-ES") return es_es2_profile_hero_xptonextlevel3(inputs)
	if (locale === "es-MX") return es_mx2_profile_hero_xptonextlevel3(inputs)
	if (locale === "fil") return fil_profile_hero_xptonextlevel3(inputs)
	if (locale === "fr") return fr_profile_hero_xptonextlevel3(inputs)
	if (locale === "it") return it_profile_hero_xptonextlevel3(inputs)
	if (locale === "hu") return hu_profile_hero_xptonextlevel3(inputs)
	if (locale === "nl") return nl_profile_hero_xptonextlevel3(inputs)
	if (locale === "no") return no_profile_hero_xptonextlevel3(inputs)
	if (locale === "pl") return pl_profile_hero_xptonextlevel3(inputs)
	if (locale === "pt-BR") return pt_br2_profile_hero_xptonextlevel3(inputs)
	if (locale === "pt") return pt_profile_hero_xptonextlevel3(inputs)
	if (locale === "ro") return ro_profile_hero_xptonextlevel3(inputs)
	if (locale === "fi") return fi_profile_hero_xptonextlevel3(inputs)
	if (locale === "sv") return sv_profile_hero_xptonextlevel3(inputs)
	if (locale === "vi") return vi_profile_hero_xptonextlevel3(inputs)
	if (locale === "tr") return tr_profile_hero_xptonextlevel3(inputs)
	if (locale === "cs") return cs_profile_hero_xptonextlevel3(inputs)
	if (locale === "bg") return bg_profile_hero_xptonextlevel3(inputs)
	if (locale === "ru") return ru_profile_hero_xptonextlevel3(inputs)
	if (locale === "uk") return uk_profile_hero_xptonextlevel3(inputs)
	if (locale === "ar") return ar_profile_hero_xptonextlevel3(inputs)
	if (locale === "hi") return hi_profile_hero_xptonextlevel3(inputs)
	if (locale === "th") return th_profile_hero_xptonextlevel3(inputs)
	if (locale === "ja") return ja_profile_hero_xptonextlevel3(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_hero_xptonextlevel3(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_hero_xptonextlevel3(inputs)
	return ko_profile_hero_xptonextlevel3(inputs)
});
export { profile_hero_xptonextlevel3 as "profile.hero.xpToNextLevel" }